<div [ngSwitch]="entityTypeCode" data-automation-id="dashboard_202130162718">
  <app-healthcare-provider-dashboard
    [redirectToTabIndex]="this.redirectedToTabIndex"
    *ngSwitchCase="EntityType.HealthcareProvider"
  ></app-healthcare-provider-dashboard>
  <app-insurer-dashboard
    [redirectToTabIndex]="this.redirectedToTabIndex"
    *ngSwitchCase="EntityType.Insurer"
  ></app-insurer-dashboard>
  <app-medical-supplier-dashboard
    [redirectToTabIndex]="this.redirectedToTabIndex"
    *ngSwitchCase="EntityType.MedicalSupplier"
  ></app-medical-supplier-dashboard>
  <app-third-party-administrator-dashboard
    [redirectToTabIndex]="this.redirectedToTabIndex"
    *ngSwitchCase="EntityType.ThirdPartyAdministrator"
  ></app-third-party-administrator-dashboard>
  <app-pharmacy-benefit-manager-dashboard
    [redirectToTabIndex]="this.redirectedToTabIndex"
    *ngSwitchCase="EntityType.PharmacyBenefitManager"
  ></app-pharmacy-benefit-manager-dashboard>
  <app-utilization-reviewer-dashboard
    [redirectToTabIndex]="this.redirectedToTabIndex"
    *ngSwitchCase="EntityType.UtilizationReviewer"
  ></app-utilization-reviewer-dashboard>
  <app-authenticated-no-group-membership *ngSwitchDefault></app-authenticated-no-group-membership>
</div>
